"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _urls = _interopRequireDefault(require("./urls"));

class VideoService {
  constructor(baseUrl, httpClient) {
    this.httpClient = httpClient;
    this.urls = (0, _urls.default)(baseUrl);
  }
  /**
   * Fetch the video data from the server by video id
   * @param {ctx} ctx - context object
   * @param {string} videoId - video id
   */


  async fetchVideoData(ctx, videoId) {
    const response = await this.httpClient.get(this.urls.GET_VIDEO(videoId), ctx);

    if (!response) {
      return null;
    }

    return response.data;
  }
  /**
   * Saves the video data in the server
   * @param {Object} videoData - video data json
   * @param {number} render - 0 (only creates the videos), 1 - (creates and render the video)
   */


  async saveDraft(videoData, render = 0) {
    const {
      id
    } = videoData;

    if (!id) {
      return this.createVideo(videoData, 0);
    }

    const url = "".concat(this.urls.CREATE_VIDEO, "/").concat(id, "?render=").concat(render);
    const response = await this.httpClient.put(url, videoData);
    return this.parseVideoResponse(response);
  }
  /**
   * Create the video data in the server
   * @param {Object} videoData - video data json
   * @param {number} render - 0 (only creates the videos), 1 - (creates and render the video)
   */


  async createVideo(videoData, render = 1) {
    const {
      id
    } = videoData;

    if (id) {
      return this.saveDraft(videoData, 1);
    }

    const url = "".concat(this.urls.CREATE_VIDEO, "?render=").concat(render);
    const response = await this.httpClient.post(url, videoData);
    return this.parseVideoResponse(response);
  }
  /**
   * Creates a new video
   * @param {Object} videoData - video data object
   * @param {bool} render - Indicates whether to render (create) the video for the first time
   */


  parseVideoResponse(response) {
    if (!response) {
      return null;
    }

    const data = response.data; // eslint-disable-next-line camelcase

    const {
      video: {
        id
      },
      rendering_duration
    } = data;
    return {
      id,
      renderingDuration: rendering_duration
    };
  }

}

var _default = VideoService;
exports.default = _default;